factboxAppAuthModal.$inject = ['$rootScope', '$route', '$parse', '$window',
  '$uibModal', 'SigninModalConf'
];

export default function factboxAppAuthModal($rootScope, $route, $parse, $window,
  $uibModal, SigninModalConf) {
  $rootScope.authModal = () => {
    if ($rootScope.authModalOpen ||
      $parse('current.$$route.originalPath')($route) === '/signin') {
      return;
    }
    $rootScope.authModalOpen = true;

    var conf = SigninModalConf;

    $uibModal.open(conf).result.then(() => {
      $rootScope.authModalOpen = false
    }, () => {
      $window.location.reload();
    })
  }
}



// WEBPACK FOOTER //
// ./project/apps/factbox-app/factbox-app.auth-modal.js